import { useTranslation } from 'react-i18next';
import { formatIntNumber } from '@anytag/shared-utils';
import { RangeSliderInputFieldProps, RangeSliderInputField } from '@anytag/shared-molecules';
import { MIN_MAX_FOLLOWERS_OPTIONS, MIN_FOLLOWERS, MAX_FOLLOWERS } from '@anytag/shared-constants';
import { InfluencersFilterFormKeys } from '../schemaTypes';

interface FollowerRangeSlideFieldProps {
  minField?: Omit<RangeSliderInputFieldProps['minField'], 'name'>;
  maxField?: Omit<RangeSliderInputFieldProps['maxField'], 'name'>;
}

export const FollowerField = ({ minField, maxField }: FollowerRangeSlideFieldProps) => {
  const { t } = useTranslation();

  return (
    <RangeSliderInputField<InfluencersFilterFormKeys>
      options={MIN_MAX_FOLLOWERS_OPTIONS}
      title={t('General.Number of Followers')}
      slideProps={{ step: 10000, min: MIN_FOLLOWERS, max: MAX_FOLLOWERS }}
      minField={{ ...minField, name: 'minFollowers', placeholder: formatIntNumber(MIN_FOLLOWERS) }}
      maxField={{ ...maxField, name: 'maxFollowers', placeholder: `${formatIntNumber(MAX_FOLLOWERS)}+` }}
    />
  );
};
